const Config = {
  baseUrl: 'https://secure1.mhelpdesk.com',
  apiUrl: 'https://secure1.mhelpdesk.com/api/api/',
  identity: {
    url: 'https://login.mhelpdesk.com',
    client_secret: 'test123',
    client_id: 'passwordless_ui',
  },
  googleMapKey: 'AIzaSyAsAabAn1M5xkm8SxZqES4XOulFIGjt9f8',
  launchDarklyClientId: '5d8cbaf46d88da078e3345ce',
  mapQuestAPI: 'https://www.mapquestapi.com/search/v3/prediction',
  mapQuestAPIKey: 's5dBmTfK0OiSbGfEL8wU9IzPfNgaPNAR',
  qbUrl: 'https://qb.mhelpdesk.com/',
  qboUrl: 'https://quickbooks.mhelpdesk.com/Default.aspx',
  fuseBill: {
    publicKey: 'bc768a8c-d575-4007-a370-19e17a256fa4',
    transparentRedirectUrl:
      'https://payments.subscriptionplatform.com/api/paymentsv2/',
  },
  authScriptUrl: 'https://js.authorize.net/v3/AcceptUI.js',
  wePayServerMode: 'production',
  wePayUrl: 'https://wepay.com/login',
  pdfUrl: '/pdf',
  recurTestInverval: false,
  flagProvider: 'launchDarkly',
  showOldEstimateInvoiceLink: false,
  envName: 'prod',
};

export default Config;



// WEBPACK FOOTER //
// ./src/config/config.Production.js